<template>
  <div>
      <el-row class="mt-2">
          <b class="font_extralarge">依据名单导出</b>        
      </el-row>
      <!-- 第二部分，上传 -->
      <el-row class="mt-2">
          <b class="font_base">1. 上传名单</b>        
      </el-row>
      <el-row class="mt-1">
        <p class="f">点击下载<a class="a-b" :href="attachmentUrl" target="_blank">模板</a></p>

        <el-upload
          class="upload-demo"
          drag
          action="/api/manager/export/readusers"
          :before-upload="onBeforeUpload"
          :on-success="onUploadSuccess"
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件，请按学时模板添加</div>
        </el-upload>
      </el-row>

      <el-row class="mt-1" v-if="haserror">
        <b class="font_base">存在不可导出的数据</b>        
      </el-row>

      <el-row v-if="datas && datas.length > 0">
        <el-table
          :data="datas"
          style="width: 100%">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            prop="uid"
            label="uid"
            width="150">
          </el-table-column>
          <el-table-column
            prop="name"
            label="学员名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="classunit"
            label="单位"
            width="500">
          </el-table-column>
          <el-table-column
            label="是否可导入"
            width="200">
            <template slot-scope="scope">
              <template v-if="scope.row.status == 0">
                <el-tag type="success">可导出</el-tag>
              </template>
              <template v-if="scope.row.status == 1">
                <el-tag type="danger">查询到重名用户</el-tag>
              </template>
              <template v-if="scope.row.status == 2">
                <el-tag type="danger">未查询到用户</el-tag>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
          <el-button style="margin-top: 12px;" type="primary" @click="publish" :loading="loading">确定</el-button>
      </el-row>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { options as optionsApi } from "@/api/module/studyclass/studyclass";
import { exportApi } from "@/api/module/export/export";

export default {
  name: "ExportGWYCurrent",
  
  mixins: [BaseVue],
  
  components: {
    // 组件注册
  },
  
  data() {
    return {
      datas: [],
      haserror: false,
      loading: false,
      attachmentUrl: "http://wkt.shsports.cn/static/file/%E5%AD%A6%E5%91%98%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xls"
    };
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    publish() {
      this.loading = true;
      
      if (!this.datas || this.datas.length == 0) {
        this.$message.error("未获得导入数据");
        this.loading = false;
        return;
      }
      
      let serverUrl = "/api/manager/export/exportByUsers";
      
      let data = {
        datas: this.datas
      };
      
      let date = new Date();
      var Y = date.getFullYear();
      var M = date.getMonth() + 1;
      var D = date.getDate();
      
      let filename = "导出数据" + Y + M + D + ".xls";
      
      // 暂未提供
      // this.$message.info("功能即将上线");
      // this.loading = false;
      
      exportApi(data, serverUrl)
        .then((res) => {
          let data = res.data;
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$message.error("服务器内部错误!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 图片上传
    onUploadSuccess(response, file, fileList) {
      console.log("onUploadSuccess", response);
      
      if (response.success) {
        this.$message.info("文件处理完成");
        
        let data = response.data;
        
        this.datas = data.datas;
        this.haserror = data.hasError;
      } else {
        this.$message.error("文件处理失败,请对照模板文件检查格式是否正确。");
      }
    },
    
    onBeforeUpload(file) {
      this.$message.info("文件已上传，请稍等");
    }
  },
  
  created() {
    // 组件创建时的逻辑
  }
};
</script>


<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>